export default __webpack_public_path__ + "static/kfar-rash-92ee635fbb5495cd05c4ad005f9cb071.png";